import { wbp } from 'Theme';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSingleSaleTableItemDiscountStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            height: 36,
            width: 150,
            display: 'flex',
            position: 'relative',
            alignItems: 'center',
            borderRadius: '100px',
            border: '1px solid #222222',

            [theme.breakpoints.up('md')]: {
                width: 180,
                height: 52
            }
        },
        valueContainer: {
            width: '60%',
            display: 'flex',
            alignContent: 'center',
            paddingLeft: 12,

            [theme.breakpoints.up('md')]: {
                paddingLeft: '19px'
            }
        },
        dropdownContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '40%',
            borderLeft: '1px solid #F1F1F1',
            height: '100%',
            cursor: 'pointer'
        },
        chevron: {
            width: 12,
            height: 12,
            marginLeft: 5,

            [theme.breakpoints.up('md')]: {
                width: 11,
                height: 11
            }
        },
        text: {
            fontSize: 14,
            lineHeight: 1,
            fontWeight: 400,
            color: '#222222',
            textTransform: 'capitalize',

            [theme.breakpoints.up('md')]: {
                fontSize: 16
            }
        },
        adornment: {
            marginTop: '-1px'
        },
        list: {
            position: 'absolute',
            right: 0,
            top: 0,
            marginTop: -1,
            marginRight: -1,
            zIndex: 10,
            border: '1px solid #000000',
            backgroundColor: '#FFFFFF',
            [theme.breakpoints.down(wbp)]: {
                borderRadius: '11px',
                padding: '10px 0px',
                width: '60px'
            },
            [theme.breakpoints.up(wbp)]: {
                borderRadius: '14px',
                padding: '12px 0px',
                width: '75px'
            }
        },
        listItem: {
            'cursor': 'pointer',
            'fontFamily': 'Poppins',
            'fontWeight': 400,
            'color': '#222222',
            'textTransform': 'uppercase',
            'textAlign': 'center',
            'width': '100%',
            [theme.breakpoints.down(wbp)]: {
                fontSize: '14px',
                lineHeight: '22px'
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '18px',
                lineHeight: '27px'
            },
            '&:hover': {
                backgroundColor: '#F4F4F4'
            }
        },
        inputRight: {
            '& input': {
                paddingRight: 11,
                textAlign: 'right'
            }
        }
    })
);
